<template>
  <div>
    <div>
      <h1
        class="header-text pb-3"
        ref="headerEditProfile"
        aria-labelledby="header for Student Export page"
        data-cy="header-admin-reports-student"
        autofocus
      >
        Student Export
      </h1>
      <div class="flex">
        <div class="flex-auto">
          <div class="mb-2">Term</div>
          <select class="mb-2 w-1/2 rounded border-dark-gray py-1" v-model="term">
            <option
              class="h-8"
              v-for="(term, key) in terms"
              :key="key"
              :value="term"
            >
              {{ term.name }}
            </option>
          </select>
        </div>
        <div class="text-right flex-auto py-6">
          <Button
            class=""
            text="Download Data"
            @click="downloadData('students.csv', records)"
          />
        </div>
      </div>
    </div>
    <div class="box-style mb-6">
      <div v-if="isLoading">
        <LoadingSpinner />
      </div>
      <div v-else>
        <dynamic-table
          :records="this.records"
          :fields="tableConfig"
          no-data-msg=""
          striped
          hover
        >
        </dynamic-table>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/reusable-components/LoadingSpinner";
import DynamicTable from "@/components/displays/admin-displays/DynamicTable";
import { get } from "@/composables/httpUtil";
import { downloadData } from "@/composables/downloadUtils";
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/reusable-components/base-level-components/Button";

export default {
  name: "Pairings",
  components: { LoadingSpinner, DynamicTable, Button },
  data() {
    return {
      isLoading: true,
      records: [],
      term: null,
      terms: [],
      tableConfig: [
        {
          display: "UST ID",
          name: "ust_id",
          sortable: false,
          class: "",
        },
        {
          display: "First Name",
          name: "first_name",
          sortable: false,
          class: "",
        },
        {
          display: "Last Name",
          name: "last_name",
          sortable: false,
          class: "",
        },
        {
          display: "Middle Name",
          name: "middle_name",
          sortable: false,
          class: "",
        },
        {
          display: "Level",
          name: "level",
          sortable: false,
          class: "",
        },
        {
          display: "Email Address",
          name: "email_address",
          sortable: false,
          class: "",
        },
      ],
    };
  },
  mounted() {
    this.fetchLookupResource().then(
      get("admin/terms")
        .then((terms) => {
          this.terms = terms.data;
          this.term = this.lookup_current_term;
        })
        .finally(() => {
          this.$watch(
            (vm) => vm.term,
            () => {
              this.isLoading = true;
              this.getData();
            },
            { immediate: true }
          );
          this.isLoading = false;
        })
    );
  },
  methods: {
    downloadData,
    getData() {
      let url = `admin/reports/student_export?term=${this.term.term_id}`;
      get(url)
        .then((results) => {
          this.records = results;
        })
        .catch((error) => {
          console.log("error in catch statement", error);
          this.records = [];
        })
        .finally(() => (this.isLoading = false));
    },
    ...mapActions(["fetchLookupResource"]),
  },
  computed: {
    ...mapGetters(["lookup_current_term"]),
  },
};
</script>

<style scoped></style>
